import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";

export default function Desktop({ children }) {
  const matches = useMediaQuery("(min-width:1024px)");

  return matches ? <>{children}</> : <></>;
}
